import React, { useEffect, useState, useRef } from 'react'
import './NavBar.scss'

import useScrollListener from 'hooks/useScrollListener'
import { MobileNavBar } from './MobileNavBar'
import { DesktopNavBar } from './DesktopNavBar'

export function NavBar({
  onItemClicked,
  activeStepPosition,
  stepStatusStr,
  brk,
  // Rendered inside a page with its own header. The scroll thresholds below
  // assume the break starts at the top of the document, which is not true
  // inline, so an inline nav is sticky and always visible instead.
  inline = false,
}) {
  const [navClassList, setNavClassList] = useState(['content '])
  const [isMobileNav, setIsMobileNav] = useState(false)
  const scroll = useScrollListener()
  const desktopNavRef = useRef(null)

  useEffect(() => {
    const _classList = ['content ']

    if (inline) {
      _classList.push('inline')
    }

    if (scroll.y > 200 && scroll.y - scroll.lastY > 0) {
      _classList.push('nav-bar--hidden')
    }

    // `init` positions the nav for a break that starts at the top of the document.
    // An inline break does not, and its own sticky positioning already covers both
    // the resting and the pinned state.
    if (!inline && scroll.y < 100) {
      // Adjust the initial position as needed
      _classList.push('init')
    }

    setNavClassList(_classList)
  }, [inline, scroll.y, scroll.lastY])

  useEffect(() => {
    const handleResize = () => {
      if (desktopNavRef.current) {
        const desktopNavWidth = desktopNavRef.current.offsetWidth
        const screenWidth = window.innerWidth

        if (screenWidth <= desktopNavWidth || screenWidth <= 600) {
          setIsMobileNav(true)
        } else {
          setIsMobileNav(false)
        }
      }
    }

    handleResize() // Initial check
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const stepStatusArr = JSON.parse(stepStatusStr)

  return (
    <nav className={navClassList.join(' ')}>
      <DesktopNavBar
        ref={desktopNavRef}
        className="desktop-navbar"
        style={{
          position: isMobileNav ? 'absolute' : 'relative',
          opacity: isMobileNav ? 0 : 1,
        }}
        onItemClicked={onItemClicked}
        activeStepPosition={activeStepPosition}
        stepStatusArr={stepStatusArr}
        brk={brk}
      />
      <MobileNavBar
        className="mobile-navbar"
        style={{
          display: isMobileNav ? 'flex' : 'none',
        }}
        onItemClicked={onItemClicked}
        activeStepPosition={activeStepPosition}
        stepStatusArr={stepStatusArr}
        brk={brk}
      />
    </nav>
  )
}
